import { render, staticRenderFns } from "./VersionTypeSelect.vue?vue&type=template&id=2e8fc9c3&"
import script from "./VersionTypeSelect.vue?vue&type=script&lang=js&"
export * from "./VersionTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports